import { Suspense, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { PageLayout } from '@/layouts/page-layout'
import { Await, Link, Outlet, useLoaderData } from 'react-router-dom'
import { EmployeeFilter } from '@/components/employee-filter'
import { LinkWithQuery } from '@/shared/components/link-with-query'
import {
  CreateButton,
  DownloadButton,
  MassiveUploadButton
} from '@/shared/components/action-buttons'
import { HasAccess } from '@permify/react-role'
import { useAuthorization } from '@/hooks'
import { EmployeeTable } from './shared/tables'
import { PageLayoutError, PageLayoutOverlay } from '@/layouts'

export const EmployeeList = () => {
  const data = useLoaderData()

  const { hasAccess } = useAuthorization({
    redirection: {
      enable: true
    }
  })
  const { t } = useTranslation()

  useEffect(() => {
    hasAccess('employee#list')
  }, [])

  return (
    <PageLayout
      title={t('employee.other')}
      actions={[
        <div className='flex gap gap-3' key='1'>
          <EmployeeFilter />
          <HasAccess permissions='employee#upload_attachments'>
            <Link to={'import'}>
              <MassiveUploadButton />
            </Link>
          </HasAccess>
          <LinkWithQuery to='reports'>
            <DownloadButton />
          </LinkWithQuery>
          <HasAccess permissions={['employee#create']}>
            <Link key='new_employee' to='create'>
              <CreateButton />
            </Link>
          </HasAccess>
        </div>
      ]}
    >
      <Outlet />

      <Suspense
        fallback={<PageLayoutOverlay />}
      >
        <Await
          resolve={data.employees}
          errorElement={
            <PageLayoutError message='No se pudieron cargar las personas' />
          }
        >
          <EmployeeTable />
        </Await>
      </Suspense>
    </PageLayout>
  )
}
